var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'alert-' +
    _vm.type +
    ' fixed bottom-10 inset-x-0 w-auto max-w-max mx-auto min-w-max text-center z-50 rounded-lg py-2 px-5 mt-2 ' +
    _vm.alertClasses,attrs:{"role":"alert"},on:{"click":_vm.forceDismiss}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }